import { create } from 'zustand';
var profile = create(function (set) { return ({
    clearProfile: function () {
        set(function () { return ({
            profileNo: undefined,
            profileName: undefined,
            profileImageUrl: undefined,
            profilePassword: undefined,
            isProfileAdd: false,
        }); });
    },
    setProfile: function (tvingProfile) {
        set(function () { return ({
            profileNo: tvingProfile.profileNo,
            profileName: tvingProfile.profileName,
            profileImageUrl: tvingProfile.profileImageUrl,
            profilePassword: undefined,
            lastFocusKey: undefined,
            isProfileAdd: false,
        }); });
    },
    setProfileNo: function (profileNo) {
        set(function () { return ({
            profileNo: profileNo,
        }); });
    },
    setProfileName: function (profileName) {
        set(function () { return ({
            profileName: profileName,
        }); });
    },
    setProfileImageUrl: function (profileImageUrl) {
        set(function () { return ({
            profileImageUrl: profileImageUrl,
        }); });
    },
    setProfilePassword: function (profilePassword) {
        set(function () { return ({
            profilePassword: profilePassword,
        }); });
    },
    setLastFocusKey: function (lastFocusKey) {
        set(function () { return ({
            lastFocusKey: lastFocusKey,
        }); });
    },
    setProfileAdd: function (isProfileAdd) {
        set(function () { return ({
            isProfileAdd: isProfileAdd,
        }); });
    },
}); });
export var useProfileStore = profile;
